import React, { useState, useRef } from 'react';
import emailjs from '@emailjs/browser';
import './Navigation.css'; // Assurez-vous que ce fichier CSS existe

const ContactModal = ({ isOpen, onClose }) => {
  const form = useRef(); 
  
  // États pour la gestion de l'UI
  const [isSending, setIsSending] = useState(false);
  // Nouveau : Pour stocker le message et son type (success ou error)
  const [status, setStatus] = useState({ message: '', type: '' });

  if (!isOpen) return null;

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  // Fonction de soumission asynchrone pour EmailJS
  const handleSubmit = (e) => {
    e.preventDefault();
    
    // REMPLACEZ CES IDs PAR LES VÔTRES !
    const SERVICE_ID = "service_4wxh7o7"; 
    const TEMPLATE_ID = "template_wiief4b";
    const PUBLIC_KEY = "qzbd5Xhalz7bRHjUC";

    if (!form.current) return;

    setIsSending(true);
    setStatus({ message: 'Envoi en cours...', type: 'info' });

    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, PUBLIC_KEY)
      .then((result) => {
        console.log('EmailJS Success:', result.text);
        
        // NOUVEAU : Message de succès stylisé
        setStatus({ message: '✅ Message envoyé ! La page va se recharger.', type: 'success' });
        
        // Réinitialiser le formulaire (optionnel, puisque la page va recharger)
        // form.current.reset(); 
        
        // NOUVEAU : Déclencher le rechargement après 2.5 secondes
        setTimeout(() => {
          // Utiliser window.location.reload() pour recharger la page
          window.location.reload(); 
        }, 2500); 

      }, (error) => {
        console.error('EmailJS Error:', error.text);
        
        // NOUVEAU : Message d'erreur stylisé
        setStatus({ message: `❌ Échec de l'envoi : ${error.text}. Veuillez réessayer.`, type: 'error' });
      })
      .finally(() => {
        // Laisser isSending à false après l'erreur ou avant le reload
        if (status.type !== 'success') {
             setIsSending(false);
        }
      });
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-content" onClick={handleContentClick}>
        
        <button className="modal-close-btn" onClick={onClose}>&times;</button>
        
        <h2>Nous Contacter</h2>
        
        <div className="modal-body-form-only">
          
          <form className="modal-form" ref={form} onSubmit={handleSubmit}>
            {/* ... Vos champs de formulaire ... */}
            <div className="form-group"><label htmlFor="name">Nom</label><input type="text" id="name" name="name" required /></div>
            <div className="form-group"><label htmlFor="email">Adresse Email</label><input type="email" id="email" name="email" required /></div>
            <div className="form-group"><label htmlFor="subject">Sujet</label><input type="text" id="subject" name="subject" required /></div>
            <div className="form-group"><label htmlFor="message">Message</label><textarea id="message" name="message" rows="4" required></textarea></div>
            
            <button 
              type="submit" 
              className="submit-btn" 
              disabled={isSending}
            >
              {isSending && status.type === 'info' ? 'Envoi...' : 'Envoyer'}
            </button>
            
            {/* NOUVEAU : Affichage du message avec classe dynamique */}
            {status.message && (
              <p className={`status-message status-${status.type}`}>
                {status.message}
              </p>
            )}
            
          </form>
          
        </div>
      </div>
    </div>
  );
};

export default ContactModal;